
// import React from "react";
// import { Link } from "react-router-dom";

// const blogPosts = [
//   {
//     title: "SICAK SU İLE HALI YIKAMA",
//     image: "/images/blog/sicak-su.png",
//     excerpt:
//       "Halı yıkama sektöründe sıcak su kullanımı genellikle yapılmaz, ancak sıcak suyla yıkamanın sağladığı hijyen etkisi büyüktür.",
//     slug: "sicak-su-ile-hali-yikama",
//   },
//   {
//     title: "PROFESYONEL HALI YIKAMA",
//     image: "/images/blog/profesyonel.png",
//     excerpt:
//       "Evde yapılan temizlikle kıyaslanamayacak düzeyde derin hijyen sağlayan profesyonel yıkama yöntemleri hakkında bilgi alın.",
//     slug: "profesyonel-hali-yikama",
//   },
//   {
//     title: "HANGİ HALI YIKAMACI",
//     image: "/images/blog/yikamaci.png",
//     excerpt:
//       "Piyasada çok fazla halı yıkamacı var. Kaliteli olanı nasıl seçersiniz? İşte dikkat edilmesi gerekenler.",
//     slug: "hangi-hali-yikamaci",
//   },
//   {
//     title: "KUYU SUYU İLE HALI YIKAMA",
//     image: "/images/blog/kuyu.png",
//     excerpt:
//       "Bazı halı yıkama firmaları maliyeti düşürmek için kuyu suyu kullanıyor. Bu durumun sağlığa ve halınıza etkilerini öğrenin.",
//     slug: "kuyu-suyu-ile-hali-yikama",
//   }
// ];

// const BlogList = () => {
//   return (
//     <section className="bg-[#f7f7d4] py-12 px-4">
//       <div className="max-w-screen-xl mx-auto">
//         <div className="flex justify-center mb-10">
//           <img
//             src="/images/headings/bloglogo.png"
//             alt="Blog Yazilari"
//             className="h-20 sm:h-28 md:h-40"
//           />
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {blogPosts.map((post, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-xl border border-gray-200 shadow-md p-4"
//             >
//               <h3 className="text-sm font-bold text-gray-800 mb-2">
//                 {post.title}
//               </h3>
//               <img
//                 src={post.image}
//                 alt={post.title}
//                 className="w-full h-48 object-cover rounded mb-3"
//               />
//               <p className="text-[14px] text-gray-700 leading-relaxed">
//                 {post.excerpt}
//               </p>
//               <div className="mt-4">
//                 <Link
//                   to={`/blog/${post.slug}`}
//                   className="inline-block bg-[#dce7d0] hover:bg-[#bdd3a6] text-gray-800 px-4 py-2 rounded-full text-sm font-medium"
//                 >
//                   Yazının Devamı
//                 </Link>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="flex justify-center mt-12">
//           <Link
//             to="/blog"
//             className="bg-[#6f8d5f] hover:bg-[#4c693e] text-white px-6 py-3 rounded-full text-lg font-semibold shadow-md transition-all duration-300"
//           >
//             Diğer Blog Yazılarımız
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BlogList;
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpenText, Sparkles } from "lucide-react";

const blogPosts = [
  {
    title: "Sıcak Su ile Halı Yıkama",
    image: "/images/blog/sicak-su.png",
    excerpt:
      "Sıcak suyla halı yıkama, hijyen etkisi yüksek bir yöntemdir. Ancak her halı türü için uygun değildir. Doğru sıcaklık ve profesyonel uygulama büyük önem taşır.",
    slug: "sicak-su-ile-hali-yikama",
  },
  {
    title: "Profesyonel Halı Yıkama",
    image: "/images/blog/profesyonel.png",
    excerpt:
      "Evde yapılan yüzeysel temizlik çoğu zaman yeterli olmaz. Profesyonel halı yıkama, toz, kir, bakteri ve kötü kokuları derinlemesine temizler.",
    slug: "profesyonel-hali-yikama",
  },
  {
    title: "Hangi Halı Yıkamacı?",
    image: "/images/blog/yikamaci.png",
    excerpt:
      "Doğru halı yıkama firmasını seçmek, halınızın ömrü ve hijyen kalitesi için çok önemlidir. Firma seçiminde dikkat edilmesi gerekenleri öğrenin.",
    slug: "hangi-hali-yikamaci",
  },
  {
    title: "Kuyu Suyu ile Halı Yıkama",
    image: "/images/blog/kuyu.png",
    excerpt:
      "Bazı firmalar maliyeti düşürmek için kuyu suyu kullanabilir. Bu durum hem hijyen açısından hem de halı dokusu açısından ciddi riskler oluşturabilir.",
    slug: "kuyu-suyu-ile-hali-yikama",
  },
];

const BlogList = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#FFF9F3] via-[#F8EFE5] to-[#FFFDFB] px-4 py-14 md:py-20">
      <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-[#C18A4A]/10 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-72 w-72 rounded-full bg-[#0E2A47]/10 blur-3xl" />

      <div className="relative z-10 mx-auto max-w-screen-xl">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#D8C2A8] bg-white/80 px-4 py-2 text-[11px] font-bold uppercase tracking-[2px] text-[#B07A3F] shadow-sm">
            <BookOpenText size={14} />
            Blog Yazıları
          </span>

          <h2 className="mt-5 text-3xl font-black leading-tight text-[#0E2A47] md:text-5xl">
            Temizlik Hakkında
            <span className="block text-[#B07A3F]">
              Faydalı Bilgiler
            </span>
          </h2>

          <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-8 text-[#6A625A]">
            Halı yıkama, koltuk temizliği ve hijyen süreçleri hakkında merak
            edilen konuları sizin için sade ve anlaşılır şekilde hazırladık.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-4">
          {blogPosts.map((post, index) => (
            <article
              key={index}
              className="group overflow-hidden rounded-[30px] border border-[#EADBCB] bg-white shadow-[0_12px_35px_rgba(0,0,0,0.05)] transition-all duration-300 hover:-translate-y-1 hover:border-[#C18A4A] hover:shadow-[0_20px_50px_rgba(0,0,0,0.1)]"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-[#0E2A47]/80 via-[#0E2A47]/20 to-transparent" />

                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-flex items-center gap-1 rounded-full bg-white/90 px-3 py-1 text-[11px] font-bold text-[#B07A3F]">
                    <Sparkles size={12} />
                    Rehber
                  </span>
                </div>
              </div>

              <div className="flex min-h-[270px] flex-col p-6">
                <h3 className="text-xl font-black leading-snug text-[#0E2A47]">
                  {post.title}
                </h3>

                <p className="mt-4 flex-1 text-[14px] leading-7 text-[#5F5750]">
                  {post.excerpt}
                </p>

                <Link
                  to={`/blog/${post.slug}`}
                  className="mt-6 inline-flex items-center justify-between rounded-full border border-[#EADBCB] bg-[#FFF8F1] px-5 py-3 text-sm font-bold text-[#0E2A47] transition-all duration-300 hover:border-[#C18A4A] hover:bg-[#C18A4A] hover:text-white"
                >
                  Yazının Devamı
                  <ArrowRight size={17} />
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <Link
            to="/blog"
            className="inline-flex items-center gap-3 rounded-full bg-[#0E2A47] px-7 py-4 text-base font-bold text-white shadow-[0_12px_30px_rgba(14,42,71,0.25)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#C18A4A]"
          >
            Diğer Blog Yazılarımız
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogList;